import React from 'react';
import { AddCaseAssessments } from 'pages/components';

const ARContactCasesAddAssessments = (props) => (
  <AddCaseAssessments {...props} />
);

export default ARContactCasesAddAssessments;
